import { render, staticRenderFns } from "./enclosure.vue?vue&type=template&id=6a46998e&scoped=true&"
import script from "./enclosure.vue?vue&type=script&lang=js&"
export * from "./enclosure.vue?vue&type=script&lang=js&"
import style0 from "./enclosure.vue?vue&type=style&index=0&id=6a46998e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a46998e",
  null
  
)

export default component.exports